var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{attrs:{"variant":_vm.log_status.badgeClass}},[_c('i',{class:'fa' + ' ' + _vm.log_status.icon}),_vm._v("\n  "+_vm._s(_vm.log_status.name)+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-477bcc63","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Orders_v2/Aggregates/Exportacao/CardLogStatus.vue
// module id = yzci
// module chunks = 0